export default __webpack_public_path__ + "assets/images/fc3a4a332a6bb884003139b5a987edd8.png";